import { useEffect, useState } from 'react';

import { Modal, TextField } from '@atom/mui';
import textDisplayUtilities from '@atom/utilities/textDisplayUtilities';

type RenameModalProps = {
  id: string;
  name: string;
  type: string;
  renameAction: (id: string, name: string) => void;
  open: boolean;
  closeModal: () => void;
  confirmText?: string;
  loading?: boolean;
  title?: string;
};

const RenameModal = ({
  id,
  name,
  type,
  renameAction,
  open,
  closeModal,
  confirmText = 'Rename',
  loading,
  title,
}: RenameModalProps) => {
  const [nameValue, setNameValue] = useState<string>(name);

  useEffect(() => {
    if (open) {
      setNameValue(name);
    }
  }, [open, name]);

  const handleConfirm = () => {
    renameAction(id, nameValue);
    closeModal();
  };

  const errorText =
    nameValue.length === 0 ? `The ${type} name cannot be blank` : '';

  return (
    <Modal
      open={open}
      title={title || `Rename ${textDisplayUtilities.capitalize(type)}`}
      confirmButtonText={confirmText}
      onConfirm={handleConfirm}
      onCancel={closeModal}
      disabled={errorText.length > 0}
      loading={loading}
      data-cy="renameModal"
    >
      <TextField
        label="Name"
        name="name"
        value={nameValue}
        autoFocus
        error={errorText.length > 0}
        helperText={errorText}
        onChange={event => setNameValue(event.target.value)}
        data-cy="renameModalNameInput"
      />
    </Modal>
  );
};

export default RenameModal;
